import { FC, memo } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { ADVERSE_MEDIA_PATH } from 'commons/constants/routes'
import { CircularProgress, Page, PageFace } from 'ui/components'
import { BSABreadcrumbs } from 'ui/temp'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types'

import { Footer, GeneralInformation } from './components'
import { PublicationsListContainer } from './components/PublicationsListContainer'
import { SelectionPublicationContextProvider } from './context/SelectionPublicationContext'

const SearchCase: FC = memo(() => {
  const routeApi = getRouteApi('/_app/adverse-media/$id')
  const loaderData = routeApi.useLoaderData({ select: (s) => s }) as AdverseMediaDetailsType

  if (!loaderData) return <CircularProgress />

  const { title } = loaderData

  return (
    <SelectionPublicationContextProvider>
      <Page
        face={PageFace.PRIMARY}
        title={<BSABreadcrumbs title={title} parentUrl={ADVERSE_MEDIA_PATH} parentTitle="Adverse Media" />}
        footer={<Footer />}
      >
        <GeneralInformation />
        <PublicationsListContainer />
      </Page>
    </SelectionPublicationContextProvider>
  )
})

export default SearchCase
